import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';

import { AppMenuItem } from '@nx-ahs/shared/models';
import { UserMenuHistoryService } from '../../../core/services/user-menu-history.service';
import { TaskService } from '../../../core/services/task.service';

import { BreadcrumbItem } from '../../../core/models/breadcrumb-item';
import { UserManagementService } from '../../../core/services/user-management.service';

@Component({
	selector: 'breadcrumb-piece',
	templateUrl: './breadcrumb-piece.component.html',
	styleUrl: './breadcrumb-piece.component.scss',
	standalone: true,
	imports: [
		CommonModule,
		FontAwesomeModule,
		FlexLayoutModule,
		MatButtonModule,
		MatMenuModule,
		MatFormFieldModule,
		MatSelectModule,
		MatInputModule
	]
})
export class BreadcrumbPieceComponent {
	@Input()
	public breadcrumbItem: BreadcrumbItem;
	@Input()
	public isActive: boolean;
	@Output()
	public breadcrumbUpdated: EventEmitter<BreadcrumbItem> = new EventEmitter<BreadcrumbItem>();

	constructor(
		private router: Router,
		private userMenuHistoryService: UserMenuHistoryService,
		private taskService: TaskService,
		private userManagementService: UserManagementService
	) {}

	public getMenuTitle(mi: AppMenuItem) {
		let title = `${mi.title}`;

		if (mi.count) title = title + ` (${mi.count})`;

		return title;
	}

	public menuNavigate(mi: AppMenuItem) {
		if (mi.url) this.router.navigate([mi.url]);
		else if (!mi.url && !mi.methodName && mi.childMenu) {
			this.router.navigate([mi.childMenu[0].url]);
		} else if (mi.methodName === 'getTaskInbox') {
			this.getTaskInbox(mi);
		} else if (mi.methodName === 'setUserManagement') {
			this.setUserManagement(mi);
		}
		// return a breadcrumb item to the parent
		const newCrumb: BreadcrumbItem = {
			menuItem: mi,
			parentMenu: this.breadcrumbItem.parentMenu,
			isInput: false,
			arrayIndex: this.breadcrumbItem.arrayIndex
		};
		// set the new breadcrumb as menu expanded
		newCrumb.menuItem.expanded = true;
		this.breadcrumbUpdated.emit(newCrumb);
		this.userMenuHistoryService.logUserMenuHistory(mi.menuItemId);
	}

	private getTaskInbox(mi: AppMenuItem) {
		const taskMetadata = mi.metadata;
		let inboxId: string;
		if (taskMetadata.taskInboxId) {
			inboxId = Array.isArray(taskMetadata.taskInboxId) ? taskMetadata.taskInboxId[0] : taskMetadata.taskInboxId;
		}

		let queueId: string;
		if (taskMetadata.taskQueueId || taskMetadata.taskQueueIds) {
			queueId = taskMetadata.taskQueueId || taskMetadata.taskQueueIds[0];
		}

		let typeId: string;
		if (taskMetadata.taskTypeId || taskMetadata.taskTypeIds) {
			typeId = taskMetadata.taskTypeId || taskMetadata.taskTypeIds[0];
		}

		const commands = ['task-inbox'];
		if (inboxId) commands.push(inboxId);

		if (queueId) commands.push(queueId);

		if (typeId) commands.push(typeId);

		if (commands.length == 1) {
			commands.push(mi.title.replace(/\s+/g, ''));
		}

		this.taskService.menuItemClicked(mi);
		this.router.navigate(commands);
	}

	public setUserManagement(mi: AppMenuItem) {
		//Send the title which should be the name of the item the user clicked off the menu
		this.userManagementService.setStartPage(mi.title);
		this.router.navigate(['admin/user-management']);
	}
}
